import { useState, useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import confetti from 'canvas-confetti';
import { NewProjectForm } from '../../forms';
export const NewProjectPage = () => {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const [isFirstTimeUser, setIsFirstTimeUser] = useState(false);

    const parsedCompanyId = parseInt(searchParams.get('companyId'), 10);
    const onBehalfCompanyId = Number.isFinite(parsedCompanyId) ? parsedCompanyId : null;
    const onBehalfCompanyName = searchParams.get('companyName');

    useEffect(() => {
        if (sessionStorage.getItem('newCompanySignup') === '1') {
            setIsFirstTimeUser(true);
            sessionStorage.removeItem('newCompanySignup');

            const duration = 2000;
            const end = Date.now() + duration;
            const frame = () => {
                confetti({
                    particleCount: 3,
                    angle: 60,
                    spread: 55,
                    origin: { x: 0 },
                });
                confetti({
                    particleCount: 3,
                    angle: 120,
                    spread: 55,
                    origin: { x: 1 },
                });
                if (Date.now() < end) requestAnimationFrame(frame);
            };
            frame();
        }
    }, []);

    console.log('Starting a new project...');

    const handleBack = () => {
        if (onBehalfCompanyId != null) {
            navigate(`/super-admin?companyId=${onBehalfCompanyId}&tab=projects`);
            return;
        }
        navigate('/');
    };

    const heading = isFirstTimeUser
        ? "Congrats on creating your account, now let's design your first solar project"
        : onBehalfCompanyName
            ? `New project for ${onBehalfCompanyName}`
            : "Let's Build Something New Together";

    return (
        <div className="page">
            <div className="main-content main-content--narrow">
                <button className="back-button" onClick={handleBack}>
                    {onBehalfCompanyId != null ? '← Back to Company' : '← Back to Dashboard'}
                </button>
                <div className="project-header project-header--compact">
                    <h1 className="project-header__title--compact">{heading}</h1>
                    <hr />
                </div>
                <NewProjectForm companyId={onBehalfCompanyId} />
            </div>
        </div>
    )
}